import { render, staticRenderFns } from "./pindaan-i.vue?vue&type=template&id=4528c603&"
import script from "./pindaan-i.vue?vue&type=script&lang=js&"
export * from "./pindaan-i.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports